// extracted by mini-css-extract-plugin
export default {"title":"f6-z","warning":"g6-z","sizeOptionsLegendText":"h6-z"};